import styled from 'styled-components'
import { Swiper } from 'swiper/react'

export const SwiperStyle = styled(Swiper)`
  &.squared {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
  }

  &.top {
    bottom: auto;
    top: 0;
  }
`
